.popular-suggests {
    h6 {
        font-size: 20px;
        font-weight: 700;
        line-height: 1.5;
        margin-bottom: 8px;
        text-transform: capitalize;
        color: $core-neutral-900;
    }

    .popular-list {
        @extend %list-reset;
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        li {
            position: relative;
            padding-top: 0;
            padding-bottom: 5px;

            & + li {
                padding-top: 16px;
            }

            a {
                color: $colour-primary-500;
                font-weight: 600;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        & > li, & > li p {
            font-size: 18px;
            font-weight: 400;
            color: $core-neutral-900;
        }
    }

    &[hidden] {
        display: none;
    }
}

#gsearch-form {
    .generic-search-container {
        margin-top: 2rem;
        display: flex;
        flex-direction: column;
        width: 100%;

        @include min(768px) {
			flex-direction: row;
            margin-top: 7.5rem;
		}

        .search-input-container, .generic-results-actions {
            flex-grow: 1;
            margin-bottom: 0.5rem;

            @include min(768px) {
                margin-bottom: 0;
                margin-right: 1rem;
            }
        }

        .search-input {
            border: 1px solid $colour-highlight;
            display: flex;
            flex-direction: row;

            input {
                border: none;
                line-height: 20px;
            }
            .reset-button {
                margin-top: 6px;
                background-color: transparent;
                border: none;
                cursor: pointer;

                svg {
                    fill: $colour-highlight;
                }

                &:disabled {
                    svg {
                        fill: #E6E6E6;
                    }
                }
            }
        }

        .submit-button {
            line-height: 18px;
        }
    }

    .generic-search-results {
        .toast-call-out {
            margin-top: 2rem;
            padding: 17px 32px;
            background-color: #DFD3E4;
            border-radius: 6px;
        }

        .pagination {
            margin-top: 2rem;

            @extend %list-reset;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: center;

            li {
                display: flex;
                align-items: center;
                flex-direction: row;
                justify-content: center;
                padding: 0;

                a {
                    position: relative;
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    justify-content: center;
                    width: 2.5rem;
                    height: 2.5rem;
                    font-size: 1.3rem;
                    line-height: 1.2;
                    letter-spacing: 0.25px;
                    color: $core-neutral-900;
                    padding: 0.2rem 0.4rem 0 0.4rem;
                    border-radius: 50%;
                    background-color: #DFD3E4;
                    box-shadow: $light-drop-shadow;
                    text-decoration: none;

                    &.active, &:hover {
                        color: $core-neutral-100;
                        background-color: $colour-highlight;
                    }
                }

                &.control a {
                    padding: 0.4rem;
                    background-color: $core-neutral-100;

                    .icon {
                        margin-right: 0;
                        display: inline-block;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: contain;
                        font-size: 0;

                        &.icon-chevron-left {
                            width: 2.4rem;
                            height: 2.4rem;
                            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjE2NCAyMC45MTRhMiAyIDAgMCAxLTIuODI4IDBsLTcuNzUtNy43NWEyIDIgMCAwIDEgMC0yLjgyOGw3Ljc1LTcuNzVhMiAyIDAgMSAxIDIuODI4IDIuODI4bC02LjMzNiA2LjMzNiA2LjMzNiA2LjMzNmEyIDIgMCAwIDEgMCAyLjgyOFoiIGZpbGw9IiM2NzEzNzUiLz48L3N2Zz4=');
                        }

                        &.icon-chevron-right {
                            width: 2.4rem;
                            height: 2.4rem;
                            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNTg2IDIuNTg2YTIgMiAwIDAgMSAyLjgyOCAwbDcuNzUgNy43NWEyIDIgMCAwIDEgMCAyLjgyOGwtNy43NSA3Ljc1YTIgMiAwIDEgMS0yLjgyOC0yLjgyOGw2LjMzNi02LjMzNi02LjMzNi02LjMzNmEyIDIgMCAwIDEgMC0yLjgyOFoiIGZpbGw9IiM2NzEzNzUiLz48L3N2Zz4=');
                        }
                    }

                    &:hover {
                        background-color: $colour-highlight;
                        color: white;

                        .icon.icon-chevron-left {
                            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjE2NCAyMC45MTRhMiAyIDAgMCAxLTIuODI4IDBsLTcuNzUtNy43NWEyIDIgMCAwIDEgMC0yLjgyOGw3Ljc1LTcuNzVhMiAyIDAgMSAxIDIuODI4IDIuODI4bC02LjMzNiA2LjMzNiA2LjMzNiA2LjMzNmEyIDIgMCAwIDEgMCAyLjgyOFoiIGZpbGw9IiNGRkZGRkYiLz48L3N2Zz4=');
                        }

                        .icon.icon-chevron-right {
                            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNTg2IDIuNTg2YTIgMiAwIDAgMSAyLjgyOCAwbDcuNzUgNy43NWEyIDIgMCAwIDEgMCAyLjgyOGwtNy43NSA3Ljc1YTIgMiAwIDEgMS0yLjgyOC0yLjgyOGw2LjMzNi02LjMzNi02LjMzNi02LjMzNmEyIDIgMCAwIDEgMC0yLjgyOFoiIGZpbGw9IiNGRkZGRkYiLz48L3N2Zz4KCg==');
                        }
                    }
                }

                & + li {
                    margin-left: 1.2em;
                }

                &:not(.control):last-child {
                    margin-right: 3.2rem;
                }

                &:not(.control):first-child, &.control + li, & + li.control {
                    margin-left: 3.2rem;
                }
            }
        }
    }
    .results-item {
        user-select: none;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.5;
        padding: 16px 24px;
        border-bottom: 2px solid $core-neutral-300;
        background-color: $core-neutral-100;
        color: $core-neutral-900;
        display: flex;
        align-items: left;
        flex-direction: column;
        justify-content: space-between;
        text-decoration: none;

        .title-text {
            display: block;
            font-weight: 700;
        }

        .description-text {
            margin-top: 0;
        }
    }
}